import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { AmpelBadgeComponent, AmpelState, openDefectKeys } from '../../../components/ampel-badge/ampel-badge.component';
import { DefectRefChipsComponent } from '../../../components/defect-ref-chips/defect-ref-chips.component';
import { ReportAbschluss, ReportAmpel } from '../../../models/release-report.model';

const AMPEL_STATE: Record<ReportAmpel, AmpelState> = {
  FREIGABEFAEHIG: 'freigabefaehig',
  NOCH_OFFEN: 'noch-offen',
  NICHT_FREIGABEFAEHIG: 'nicht-freigabefaehig',
};

@Component({
  selector: 'app-report-doc-abschluss',
  imports: [DatePipe, TranslatePipe, AmpelBadgeComponent, DefectRefChipsComponent],
  templateUrl: './report-doc-abschluss.component.html',
  styleUrl: './report-doc-abschluss.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportDocAbschlussComponent {
  readonly abschluss = input.required<ReportAbschluss>();
  readonly scopeLabel = input.required<string>();
  readonly projectId = input.required<string>();

  protected readonly ampel = computed<AmpelState>(() => AMPEL_STATE[this.abschluss().ampel]);
  protected readonly offeneFehlerKeys = computed(() => openDefectKeys(this.abschluss().offeneDefects));
  protected readonly failedMuss = computed(() => this.abschluss().bewertung.abweichungen.filter((k) => k.muss).length);
  protected readonly failedSoll = computed(() => this.abschluss().bewertung.abweichungen.filter((k) => !k.muss).length);
  protected readonly requirementsWithoutCase = computed(() =>
    this.abschluss().traceability.filter((r) => !r.testCaseId),
  );
}
